import { useCallback } from 'react';
import { Info } from '@beeline.com/react-spreadsheet-import';
import { RsiData, RsiFieldKey, RsiTableOnErrorCallback, RsiTableValidator } from '../../../Types';
import {
  validateUsingMetadata,
  ValidationMetadataParams
} from '../../../validations/impl/metadata/useValidateRowUsingMetadata';

export const useValidateTableUsingMetadata = ({
  urnToFieldMetadataMap,
  fieldMetadataValidator
}: ValidationMetadataParams): RsiTableValidator => {
  return useCallback(
    (table: RsiData[], addError: RsiTableOnErrorCallback) => {
      table.forEach((row, index) =>
        validateUsingMetadata(
          row,
          (fieldKey: RsiFieldKey, error: Info) => {
            addError(index, fieldKey, error);
          },
          urnToFieldMetadataMap,
          fieldMetadataValidator
        )
      );
    },
    [urnToFieldMetadataMap, fieldMetadataValidator]
  );
};
